import React from "react"
import CustomButton from "../../shared/CustomButton"
import { FilePicker } from "react-file-picker"
import UserInfo from "./UserInfo"
import UserInfoEdit from "./UserInfoEdit"
import UserAddressContainer from "../../shared/Address/AddressContainer"
import NewAddressForm from "../../shared/Address/NewAddressForm"
import UserPasswordEdit from "./UserPasswordEdit"
import {
  withContainers,
  CampaignUserContainer,
  AddressContainer,
  Avatar
} from "../../normalizer"

const UserDetails = props => {
  const {
    user,
    campaignUser,
    addresses,
    editingUserGeneralData,
    onEditGeneralData,
    isAdding,
    countries,
    states,
    selectedCountry,
    selectedState,
    onEditCancel,
    onEditSubmit,
    onNewAddressEnable,
    editPassword,
    onEditPassword,
    onEditPasswordCancel,
    onEditPasswordSubmit,
    onChangeGender,
    onAvatarChange,
    errors
  } = props

  const { avatar: campaignAvatar = {} } = campaignUser

  let avatar = undefined
  if (campaignAvatar && campaignAvatar.url) {
    avatar = campaignAvatar.url
  }

  const showUserInfo = !editingUserGeneralData && !editPassword

  return (
    <>
      <div className="mb-10 mt-5 flex flex-col navbar-text">
        <div className="flex g-profile__column">
          <div className="g-profile__image-container mb-10">
            <img
              src={avatar || Avatar}
              alt="avatar"
              className="g-profile__image"
            />
            <FilePicker
              extensions={["jpg", "jpeg", "png"]}
              onChange={onAvatarChange}
              onError={() => onAvatarChange(null)}
            >
              <CustomButton>Alterar imagem</CustomButton>
            </FilePicker>
          </div>
          {showUserInfo && <UserInfo {...user} />}
          {editingUserGeneralData && (
            <UserInfoEdit
              onChangeGender={onChangeGender}
              onEditSubmit={onEditSubmit}
              {...user}
            />
          )}
          {editPassword && (
            <UserPasswordEdit onEditPasswordSubmit={onEditPasswordSubmit} />
          )}
        </div>
        {editingUserGeneralData && (
          <div className="flex justify-end  g-profile__between">
            <CustomButton className="mr-3" onClick={onEditCancel}>
              Cancelar
            </CustomButton>
            <CustomButton primary type={"submit"} form={"user-update-form"}>
              Guardar
            </CustomButton>
          </div>
        )}
        {editPassword && (
          <div className="flex justify-end  g-profile__between">
            <CustomButton className="mr-3" onClick={onEditPasswordCancel}>
              Cancelar
            </CustomButton>
            <CustomButton primary type={"submit"} form={"user-update-form"}>
              Guardar
            </CustomButton>
          </div>
        )}
        {showUserInfo && (
          <div className="flex justify-end g-profile__between">
            <CustomButton className="mr-5" onClick={onEditPassword}>
              Alterar password
            </CustomButton>
            <CustomButton outline right onClick={onEditGeneralData}>
              Editar
            </CustomButton>
          </div>
        )}
      </div>

      {addresses.map(address => (
        <UserAddressContainer key={address.id} address={address} />
      ))}

      {isAdding ? (
        <div>
          <h3 className="g-profile__title">Adicionar morada</h3>
          <NewAddressForm
            errors={errors}
            state={selectedState}
            country={selectedCountry}
            availableStates={states}
            availableCountries={countries}
            onAddressCreationCancel={props.onNewAddressCancel}
            onNewAddress={props.onNewAddressCreation}
            onCountryChange={props.onCountryChange}
            onStateChange={props.onStateChange}
          />
        </div>
      ) : (
        <div className="flex g-profile__center">
          <CustomButton primary onClick={onNewAddressEnable}>
            Adicionar morada
          </CustomButton>
           
        </div>
      )}
    </>
  )
}

export default withContainers(UserDetails, [
  CampaignUserContainer,
  AddressContainer
])
